import { render, staticRenderFns } from "./topTitle.vue?vue&type=template&id=7a0c268e&scoped=true&"
import script from "./topTitle.vue?vue&type=script&lang=js&"
export * from "./topTitle.vue?vue&type=script&lang=js&"
import style0 from "./topTitle.vue?vue&type=style&index=0&id=7a0c268e&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c268e",
  null
  
)

export default component.exports